import { compensationExtraSections } from "./MemberCompensationTab";
import { MemberCommissionSection } from "./MemberCommissionSection";

compensationExtraSections.push((member) => <MemberCommissionSection member={member} />);
